// test1936
(1936 && 0);
